
import { Product } from "@/types/product";

export const hdbasetAccessories: Product[] = [
  {
    id: "dxe-cat-rk3-2",
    groupId: "hdbaset",
    name: "DXE-CAT-RK3-2",
    description: "The DXE-CAT-RK3 allows you to fit up to 16 DXE extenders in a 3RU rack space. With all connectors on the rear of the DXE unit, this allows for a clean, organized rack installation.\n\nBlank cover plates available for empty slots (DXE-CAT-RK3BL).\n \nNOTE: DXE-CAT units not included",
    features: [
      "Perfect solution for a clean rack installation",
      "Holds up to 16 DXE series extenders",
      "Vertical unit mounting and cutouts allow for optimal ventilation."
    ],
    image: "/lovable-uploads/9dea9d8e-f4be-48e9-93e0-043f5a7ebb91.png",
    images: [
      "/lovable-uploads/9dea9d8e-f4be-48e9-93e0-043f5a7ebb91.png",
      "/lovable-uploads/6c1dd786-56a3-4cbf-a51e-cfeada6d106c.png"
    ],
    slug: "dxe-cat-rk3-2"
  }
];
